export const GET_EVENT_STATUSES = "GET_EVENT_STATUSES";
export const GET_EVENT_STATUSE_BY_ID = "GET_EVENT_STATUSE_BY_ID";
export const UPDATE_EVENT_STATUSE = "UPDATE_EVENT_STATUSE";
export const DELETE_EVENT_STATUSE = "DELETE_EVENT_STATUSE";
export const CREATE_EVENT_STATUSE = "CREATE_EVENT_STATUSE";
